/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1TagId202,
  DeleteApiV1TagId401,
  DeleteApiV1TagId404,
  DeleteApiV1TagId409,
  DeleteApiV1TagId500,
  DeleteApiV1TagIdMutationResponse,
  DeleteApiV1TagIdPathParams,
} from "../../types/tagRegistroController/DeleteApiV1TagId.ts";

export const deleteApiV1TagIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1TagIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1TagId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1TagId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1TagId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1TagId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1TagId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1TagId404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const deleteApiV1TagId409Schema =
  z.any() as unknown as ToZod<DeleteApiV1TagId409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1TagId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1TagId500>;

export const deleteApiV1TagIdMutationResponseSchema = z.lazy(
  () => deleteApiV1TagId202Schema,
) as unknown as ToZod<DeleteApiV1TagIdMutationResponse>;
